import { createActions } from 'redux-actions';


const actionCreators = createActions({
    API: {
        GET: (url, payload) => ({ method: 'get', url, ...payload }),
        PUT: (url, payload) => ({ method: 'put', url, ...payload }),
        POST: (url, payload) => ({ method: 'post', url, ...payload }),
        PATCH: (url, payload) => ({ method: 'patch', url, ...payload }),
        DELETE: (url, payload) => ({ method: 'delete', url, ...payload }),
    },
});


export default actionCreators.api;
